// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__aTDLo","title":"style__title__QfW3w","module":"style__module__d69Nl","content":"style__content__Is3ek"};